import { render, staticRenderFns } from "./QuotationTableCostsViewerAgricola.vue?vue&type=template&id=0a962918"
import script from "./QuotationTableCostsViewerAgricola.vue?vue&type=script&lang=js"
export * from "./QuotationTableCostsViewerAgricola.vue?vue&type=script&lang=js"
import style0 from "./QuotationTableCostsViewerAgricola.vue?vue&type=style&index=0&id=0a962918&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports